// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"dfefa0e5","703":"8b506bfe"}[chunkId] + ".chunk.js";
};